import { SxProps, Theme } from "@mui/material";

const previewButtonSize = { xs: "28px", sm: "30px" };
export const previewWaveHeight = 16;

export const containerStyle = (theme: Theme): SxProps<Theme> => ({
  display: "flex",
  alignItems: "center",
  gap: { xs: "6px", sm: "8px" },
  width: "100%",
  minHeight: { xs: "34px", sm: "36px" },
  px: { xs: 0.25, sm: 0.5 },
  py: 0,
});

export const previewContainerStyle: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  display: "flex",
  alignItems: "center",
};

export const audioControlsStyle = (theme: Theme): SxProps<Theme> => ({
  display: "flex",
  alignItems: "center",
  gap: { xs: "6px", sm: "8px" },
  width: "100%",
  minHeight: { xs: "34px", sm: "36px" },
  backgroundColor: "rgba(0, 0, 0, 0.02)",
  borderRadius: "999px",
  px: { xs: 0.75, sm: 1 },
  py: 0.25,
  border: `1px solid ${theme.palette.footer?.textInput?.border ?? "rgba(6, 182, 212, 0.35)"}`,
  boxSizing: "border-box",
});

export const playButtonStyle: SxProps<Theme> = {
  width: { xs: "24px", sm: "26px" },
  height: { xs: "24px", sm: "26px" },
  borderRadius: "50%",
  flexShrink: 0,
  color: "#ffffff",
  p: 0,
  background: "linear-gradient(180deg, #28C9DC 0%, #7B49C1 100%)",
  "&:hover": {
    background: "linear-gradient(180deg, #20B6C8 0%, #7C4ABF 100%)",
    transform: "scale(1.03)",
  },
  "& svg": {
    width: "11px",
    height: "11px",
  },
};

export const audioInfoStyle: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  gap: { xs: "6px", sm: "8px" },
  minWidth: 0,
};

export const audioDurationStyle = (theme: Theme): SxProps<Theme> => ({
  fontSize: { xs: "11px", sm: "12px" },
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontFamily: "monospace",
  minWidth: { xs: "28px", sm: "32px" },
  flexShrink: 0,
  lineHeight: 1,
});

export const audioWaveformStyle: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  minWidth: 0,
  height: `${previewWaveHeight}px`,
};

export const cancelButtonStyle: SxProps<Theme> = {
  width: previewButtonSize,
  height: previewButtonSize,
  borderRadius: "50%",
  flexShrink: 0,
  color: "#ffffff",
  p: 0,
  backgroundColor: "#FF3B30",
  "&:hover": {
    backgroundColor: "#DC2626",
    transform: "scale(1.03)",
  },
  "& svg": {
    width: "14px",
    height: "14px",
  },
};
